import { render, staticRenderFns } from "./projectAndAssignment.vue?vue&type=template&id=7b9bdc55&"
import script from "./projectAndAssignment.vue?vue&type=script&lang=js&"
export * from "./projectAndAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports